import { useEffect } from 'preact/hooks';
import { BoardNav } from './components/BoardNav';
import { BombMeter, DANGER_HEAT } from './components/BombMeter';
import { ClueForm } from './components/ClueForm';
import { Effects } from './components/Effects';
import { EndCard } from './components/EndCard';
import { GenerateModal } from './components/GenerateModal';
import { Goal } from './components/Goal';
import { Grid } from './components/Grid';
import { Header } from './components/Header';
import { HeatFlight } from './components/HeatFlight';
import { HelpModal } from './components/HelpModal';
import { History } from './components/History';
import { LevelsModal } from './components/LevelsModal';
import { SettingsModal } from './components/SettingsModal';
import { t } from './i18n/ru';
import { useController } from './state/context';

export function App() {
  const c = useController();

  useEffect(() => {
    void c.init();
  }, [c]);

  const status = c.status.value;
  const modal = c.modal.value;
  const game = c.game.value;
  const showGame = status !== 'error' || game;
  // Жар бомбы окрашивает весь экран: чем ближе взрыв, тем краснее фон
  const heat = game ? (game.status === 'lose' ? 1 : Math.min(1, game.heat)) : 0;
  const danger = game?.status === 'play' && heat >= DANGER_HEAT;

  return (
    <div class={danger ? 'app danger' : 'app'} style={{ '--heat': heat }}>
      <div class="ambient" aria-hidden="true">
        <i class="a" />
        <i class="b" />
        <i class="c" />
        <i class="heat" />
      </div>
      <div class="wrap">
        <Header />
        <BoardNav />
        {status === 'error' && (
          <div class="banner" role="alert" data-testid="load-error">
            {c.loadError.value}
            <button type="button" onClick={() => void c.retry()}>
              {t.retry}
            </button>
          </div>
        )}
        <BombMeter />
        {showGame && <Goal />}
        {showGame && <Grid />}
        <ClueForm />
        <EndCard />
        <History />
        {modal === 'help' && <HelpModal />}
        {modal === 'settings' && <SettingsModal />}
        {modal === 'levels' && <LevelsModal />}
        <GenerateModal />
      </div>
      <Effects />
      <HeatFlight />
    </div>
  );
}
